
import monitorTable from '@/components/monitorTable'
export default {
    components:{
      monitorTable
    },
    data(){
        return {
          noticeData:[],
          page:1,
          pagesize:5,
          total:0,
          isok:false
        }
    },
  created () {
    this.getapilist()
    this.getnodelist()
    this.getNotice()
  },
  methods:{
    // 获取报警通知
    async getNotice(){
      try{
        const {data} = await this.$http.post('/task/tasklog',{page:this.page,eachpage:this.pagesize})
        if(data.status=='success'){
          data.data.forEach(item=>{
            if(item.tongzhitype==100){
              item.msg=item.msg.replace(item.task_id,`<span style="color: #0f9fff">${item.task_id}</span>`)
            }
          })
          this.noticeData = data.data
          this.total = data.total
        }else{
          this.$message.error('获取报警通知失败')
        }
      }catch (e){
        this.$message.error('网络异常,请稍后重试')
      }
    },
    // 获取监控方式列表
    async getapilist(){
      const{data}=await this.$http.post('/apiinterface/apilist')
      if(data.status=='success'){
        var arr = data.data.filter(item=>{
          return item.taskswitch == 1
        })
        await this.$store.commit('setOther',{name:'apilist',value:arr})
        this.isok=true
      }else{
        this.$message.error(data.msg)
      }
    },
    // 获取节点列表
    async getnodelist(){
      const {data} = await this.$http.post('/apiinterface/nodelist')
      if(data.status == 'success'){
        this.$store.commit('setOther',{name:'nodelist',value:data.data})
      }else {
        this.$message.error(data.msg)
      }
    },
    // 改变页码
    currentChange(val){
      this.page = val
      this.getNotice()
    }
  }

}
